module.exports = function getResource(label, vars = []) {
    let resources = {
        view12More: 'View 12 More'
    };
    return resources[label];
};
